import { gerarPDF } from "./gerarPDF";

export const itau = {
  gerarPDF,
};
